<input
  class="tt-interval-input_value"
  max="999"
  placeholder="0"
  ttInput
  type="number"
  [ngModel]="_value"
  (ngModelChange)="onValueChange($event)" />

<tt-select class="tt-interval-input_date-type" [ngModel]="_dateType" (ngModelChange)="onDateTypeChange($event)">
  <tt-select-items>
    <tt-option value="a">{{ 'TimeSpan.a.more' | transloco }}</tt-option>
    <tt-option value="mo">{{ 'TimeSpan.mo.more' | transloco }}</tt-option>
    <tt-option value="wk">{{ 'TimeSpan.wk.more' | transloco }}</tt-option>
    <tt-option value="d">{{ 'TimeSpan.d.more' | transloco }}</tt-option>
    <tt-option value="h">{{ 'TimeSpan.h.more' | transloco }}</tt-option>
    <tt-option value="c">{{ 'TimeSpan.c.more' | transloco }}</tt-option>
  </tt-select-items></tt-select
>
